import styled from 'styled-components';
import { Colors } from 'modules/theme';

const TABLE_BORDER = '#ecebf0';
const TABLE_SHADOW = '0 1px 6px rgba(0, 0, 0, 0.05)';

const Table = styled.div`
  overflow-x: auto;
  display: block;
  max-width: 100%;
  margin: 0;
  border-radius: 12px;
  border: 1px solid ${TABLE_BORDER};
  background-color: ${Colors.white};
  box-shadow: ${TABLE_SHADOW};
  -webkit-overflow-scrolling: touch;
  @media (max-width: 767px) {
    border-radius: 12px;
    margin: 0 -4px;
  }
`;

export const THeader = styled.div`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  min-width: ${props => (props.minWidth ? props.minWidth : '600')}px;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  background-color: ${Colors.lightGray};
  border-bottom: 1px solid ${TABLE_BORDER};
`;

export const TableTitle = styled.div`
  box-sizing: border-box;
  width: ${props => props.width};
  color: ${Colors.gray8};
  text-align: ${props => (props.textAlign ? props.textAlign : 'center')};
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  align-self: center;
  justify-content: center;
  padding: 14px 16px;
  line-height: 1.4;
  border-right: 1px solid ${TABLE_BORDER};
  white-space: nowrap;
  flex-shrink: 0;
  &:last-child {
    border-right: none;
  }
  @media (max-width: 767px) {
    padding: 12px 14px;
    font-size: 12px;
  }
`;

export const TBody = styled.div``;

export const TRow = styled.div`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  min-width: ${props => (props.minWidth ? props.minWidth : '600')}px;
  box-sizing: border-box;
  transition: background-color 0.15s ease;
  ${props => !props.minimal && `border-bottom: 1px solid ${TABLE_BORDER};`}
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background-color: ${Colors.lightGray};
  }
`;

export const TableItem = styled.div`
  box-sizing: border-box;
  width: ${props => props.width};
  color: ${props => props.color || Colors.black2};
  text-align: ${props => (props.textAlign ? props.textAlign : 'center')};
  justify-content: center;
  align-self: center;
  padding: 14px 16px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.4;
  border-right: 1px solid ${TABLE_BORDER};
  white-space: nowrap;
  flex-shrink: 0;
  &:last-child {
    border-right: none;
  }
  ${props =>
    !props.isComponent &&
    `
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
  `};
  @media (max-width: 767px) {
    padding: 12px 14px;
    font-size: 13px;
  }
`;

export const TableItemMinimal = styled.div`
  width: ${props => props.width};
  color: ${props => props.color || Colors.black};
  align-self: center;
  padding: 8px 12px;
  font-style: normal;
  font-weight: ${props => props.fontweight || '325'};
  font-size: 14px;
  line-height: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  white-space: nowrap;
  align-items: center;
  display: flex;
  ${props => !props.noBorder && `border-right: 1px solid ${TABLE_BORDER};`}
`;

export const TableSubItem = styled.div`
  width: ${props => props.width};
  color: ${props => props.color || Colors.black};
  padding: 8px 12px;
  font-style: normal;
  font-weight: 325;
  font-size: 14px;
  line-height: 40px;
  ${props =>
    !props.isComponent &&
    `
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
  `};
  ${props =>
    !props.minimal &&
    `text-align: ${props => (props.textAlign ? props.textAlign : 'center')};
     justify-content: center;
     align-self: center;
    `}
`;

export default Table;
